var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 1.6424V0.309063H3.66659V1.6424H0.999919C0.631732 1.6424 0.333252 1.94088 0.333252 2.30906V12.9757C0.333252 13.3439 0.631732 13.6424 0.999919 13.6424H12.9999C13.3681 13.6424 13.6666 13.3439 13.6666 12.9757V2.30906C13.6666 1.94088 13.3681 1.6424 12.9999 1.6424H10.3333V0.309063H8.99992V1.6424H4.99992ZM1.66659 6.30906H12.3333V12.3091H1.66659V6.30906ZM1.66659 2.97573H3.66659V3.6424H4.99992V2.97573H8.99992V3.6424H10.3333V2.97573H12.3333V4.97573H1.66659V2.97573ZM5.58567 6.952L6.99992 8.36626L8.41405 6.952L9.35692 7.89473L7.94272 9.30913L9.35685 10.7232L8.41412 11.666L6.99992 10.2519L5.58562 11.666L4.64287 10.7231L6.05705 9.30913L4.64283 7.89473L5.58567 6.952Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.189258c7f8df9f3003a4a5f5b87e9f83.svg";
export { ForwardRef as ReactComponent };